import { useGlobalVariables } from '../globalConfig/securedConfigHook';

export const useIsVerticalAppFlag = () => {
  const { isVerticalAppsEnabled } = useGlobalVariables();
  return isVerticalAppsEnabled;
};
